
const SIGN_UP_POPUP = (locale) => {
    switch (locale) {
        case 'en-US':
            return 'sign_up_popup_en_us'
    }
}

export const LocalStorageKeys = {
    SIGN_UP_POPUP
}